import { ItemInput } from 'models/itemInput';
import { AreaOfSpecialisationArray } from 'queries/clinicalAttributes';

export enum ClinicalArea {
  ROLE = 'roleIds',
  SOC = 'siteOfCareIds',
}

export const getClinicalAreaFromAOS = (
  aosId: string | undefined,
  aosArray: AreaOfSpecialisationArray | undefined,
  clinicalArea: ClinicalArea,
) => {
  if (!aosId || !aosArray) return undefined;
  const selectedAos = aosArray.find(aos => aos.id === aosId);
  if (selectedAos) {
    return selectedAos[clinicalArea];
  } else return undefined;
};

export const getItemInputFromIds = (
  itemInputArr: ItemInput[] | undefined,
  idArr: string[] | undefined,
) => {
  if (!itemInputArr || !idArr) return undefined;
  return itemInputArr.filter(allItems => idArr?.some(id => id === allItems.id));
};

export const getLabelsFromIds = (
  itemInputArr: ItemInput[] | undefined,
  idArr: string[] | undefined,
): string[] => {
  if (!itemInputArr || !idArr) return [''];
  return itemInputArr
    .filter(allItems => idArr?.some(id => id === allItems.id))
    .map(item => item.name.en);
};
